<style>
  .sum .ivu-row .ivu-form-item {
    margin-bottom: 5px;
  }
</style>
<template>
  <div>
    <div class="list">
      <div class="breadcrumb" style="height: 40px">
        <Breadcrumb>
          <Breadcrumb-item href="#">财务管理</Breadcrumb-item>
          <Breadcrumb-item>收入统计</Breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>
    <div style="margin-bottom:10px" @keyup.enter="search">
      <Form :label-width="80" label-position="left">
        <Row :gutter="16">
          <Col span="8">
          <FormItem label="时间：" :label-width="50">
            <Row>
              <Col :span="11">
                <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                v-model="startDate" @on-change="beginTimeChange" style="width: 100%;"></Date-picker>
              </Col>
              <Col :span="1" style="text-align: center">-</Col>
              <Col :span="11">
                <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                v-model="endDate" @on-change="endTimeChange" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </FormItem>
          </Col>
          <Col span="4">
          <FormItem label="支付方式：">
            <Select  v-model.number="queryParam.payWay" placeholder="请选择" clearable>
              <Option v-for="item in $constant.payWay" :key="item.code" :value="item.code">{{item.text}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="4">
          <Form-item label="学员ID：" :label-width="80">
            <Input placeholder="学生id" v-model="queryParam.uid" ></Input>
          </Form-item>
          </Col>
          <Col span="4">
          <Form-item label="学员姓名：" :label-width="80">
            <Input placeholder="学生姓名" v-model="queryParam.nickname"></Input>
          </Form-item>
          </Col>
          <Col span="2">
          <Button type="primary" icon="search" @click="search" :loading="searchLoading" :disable="searchLoading">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div style="margin-bottom:10px;font-size: small" class="sum">
      <Form :label-width="80" label-position="left">
        <Row>
          <Col span="3" > <Form-item label="套餐金额："> {{statisticsSum.amountSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="订单金额："> {{statisticsSum.payAmountSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="订单课时："> {{statisticsSum.orderLessonNumSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="赠送课时："> {{statisticsSum.totalOtherDiscountNumSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="合计课节："> {{statisticsSum.totalLessonNumSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="本期消耗："> {{statisticsSum.periodUseNumSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="本期赠送："> {{statisticsSum.periodOtherDiscountNumSum}}</Form-item></Col>
        </Row>
        <Row >
          <Col span="3"> <Form-item label="累计消耗："> {{statisticsSum.totalUseNumSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="剩余课时："> {{statisticsSum.leaveLessonNumSum}}</Form-item></Col>
          <Col span="3"> <Form-item label="课时均价："> {{statisticsSum.averagePriceSum  | numFilter}}</Form-item></Col>
          <Col span="3"> <Form-item label="本期收入："> {{statisticsSum.periodIncomeSum  | numFilter}}</Form-item></Col>
          <Col span="3"> <Form-item label="剩余：" > {{statisticsSum.totalLeaveAmountSum  | numFilter}}</Form-item></Col>
          <Col span="3"> <Form-item label="退费："> {{statisticsSum.refundAmountSum  | numFilter}}</Form-item></Col>
        </Row>
      </Form>
      <!--套餐金额:{{statisticsSum.amountSum}}-->
      <!--订单金额:{{statisticsSum.payAmountSum}}-->
      <!--订单课时:{{statisticsSum.orderLessonNumSum}}-->
      <!--赠送课时:{{statisticsSum.totalOtherDiscountNumSum}}-->
      <!--合计课节:{{statisticsSum.totalLessonNumSum}}-->
      <!--本期消耗:{{statisticsSum.periodUseNumSum}}-->
      <!--本期赠送:{{statisticsSum.periodOtherDiscountNumSum}}-->
      <!--累计消耗:{{statisticsSum.totalUseNumSum}}-->
      <!--剩余课时:{{statisticsSum.leaveLessonNumSum}}-->
      <!--课时均价:{{statisticsSum.averagePriceSum}}-->
      <!--本期收入:{{statisticsSum.periodIncomeSum}}-->
      <!--剩余:{{statisticsSum.totalLeaveAmountSum}}-->
      <!--退费:{{statisticsSum.refundAmountSum}}-->
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
        @click="exportData">导出
      </Button>
    </div>
    <List ref="dataList" :params="queryParam" :tableColumns="title" listUrl="/fundPackage/incomeStatistics" :reload="reload" :onLoading="onLoading"></List>
  </div>
</template>
<script>
  export default {
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        startDate: '',
        endDate: '',
        statisticsSum: {},
        queryParam: {
          uid: '',
          nickName: '',
          payWay: null,
          beginTime: '',
          endTime: ''
        },
        title: [
          {
            title: '学生ID/姓名',
            width: 150,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + ' ' + row.nickname)
            }
          },
          {
            title: '订单号',
            width: 150,
            align: 'center',
            key: 'orderId'
          },
          {
            title: '支付方式',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let payWayEnum = $constant.getEnum($constant.payWay, params.row.payWay)
              return h('span', payWayEnum && payWayEnum.text)
            }
          },
          {
            title: '套餐金额',
            width: 100,
            align: 'center',
            key: 'amount'
          },
          {
            title: '订单金额',
            width: 100,
            align: 'center',
            key: 'payAmount'
          },
          {
            title: '订单课时',
            width: 100,
            align: 'center',
            key: 'orderLessonNum'
          },
          {
            title: '赠送课时',
            width: 100,
            align: 'center',
            key: 'totalOtherDiscountNum'
          },
          {
            title: '合计课节',
            width: 100,
            align: 'center',
            key: 'totalLessonNum'
          },
          {
            title: '本期消耗',
            width: 100,
            align: 'center',
            key: 'periodUseNum'
          },
          {
            title: '本期赠送',
            width: 100,
            align: 'center',
            key: 'periodOtherDiscountNum'
          },
          {
            title: '累计消耗',
            width: 100,
            align: 'center',
            key: 'totalUseNum'
          },
          {
            title: '剩余课时',
            width: 100,
            align: 'center',
            key: 'leaveLessonNum'
          },
          {
            title: '课时均价',
            width: 100,
            align: 'center',
            render: (h, params) => {
              return h('span', Number(params.row.averagePrice).toFixed(2))
            }
          },
          {
            title: '本期收入',
            width: 100,
            align: 'center',
            render: (h, params) => {
              return h('span', Number(params.row.periodIncome).toFixed(2))
            }
          },
          {
            title: '剩余',
            width: 100,
            align: 'center',
            render: (h, params) => {
              return h('span', Number(params.row.totalLeaveAmount).toFixed(2))
            }
          },
          {
            title: '退费',
            width: 110,
            align: 'center',
            render: (h, params) => {
              return h('span', Number(params.row.refundAmount).toFixed(2))
            }
          }
        ]
      }
    },
    mounted: function () {
      this.loadStatisticsSum()
    },
    filters: {
      // 保留小数点后两位的过滤器，尾数四舍五入
      numFilter (value) {
        let realVal = Number(value).toFixed(2)
        return Number(realVal)
      }
    },
    created: function () {
      let momentDate = this.$moment()
      momentDate.millisecond(0)
      momentDate.second(0)
      momentDate.minute(0)
      momentDate.hour(0)
      momentDate.date(1)
      this.startDate = momentDate.toDate()
      this.endDate = this.$moment().toDate()
      console.log('this.$moment():' + this.$moment())
      console.log('this.$moment().toDate():' + this.$moment().toDate())
      this.queryParam.beginTime = momentDate.format('X')
      this.queryParam.endTime = this.$moment().format('X')
    },
    methods: {
      loadStatisticsSum () {
        let self = this
        this.$http.post('/fundPackage/incomeStatistics/sum', self.queryParam).then(function (res) {
          self.statisticsSum = res.data
        })
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      beginTimeChange (value) {
        this.queryParam.beginTime = value && this.$moment(value, 'YYYY-M-D').format('X')
      },
      endTimeChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D').format('X')
      },
      search () {
        this.reload = new Date().getTime()
        this.loadStatisticsSum()
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/fundPackage/incomeStatistics/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          if (response.data) {
            let blob = new Blob([response.data], {type: 'text/csv'})
            let link = document.createElement('a')
            link.target = '_blank'
            link.href = window.URL.createObjectURL(blob)
            link.download = '收入统计.csv'
            link.click()
            this.exportLoading = false
          } else {
            this.$Message.error(response.msg)
          }
        }).catch((e) => {
          this.exportLoading = false
        })
      },
    }
  }

</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// IncomeStatistics.vue?54b7ecbe